import { http } from '@/utils/http.js';
import { teamPath } from '@/utils/paths.js';

export const WebhooksApi = {
  getWebhooks(query) {
    return http.get(`${teamPath()}/webhooks`, { params: query }).then((response) => response.data);
  },

  getWebhook(id) {
    return http.get(`${teamPath()}/webhooks/${id}`).then((response) => response.data.data);
  },

  createWebhook(data) {
    return http.post(`${teamPath()}/webhooks`, data).then((response) => response.data.data);
  },

  updateWebhook(id, data) {
    return http.patch(`${teamPath()}/webhooks/${id}`, data).then((response) => response.data.data);
  },

  deleteWebhook(id) {
    return http.delete(`${teamPath()}/webhooks/${id}`).then((response) => response.data.data);
  },
};
